import { FC, MouseEvent } from 'react'
import styled from 'styled-components'

import COLOR from '@/components/cell/designTokens/color'

interface ContainerProps {
  $padding: number
  $radius: number
  $hasBorder: boolean
  $backgroundColor: string
}
const Container = styled.div<ContainerProps>`
  padding: ${(props) => props.$padding}px;
  border: 1px solid ${COLOR.gray400};
  border-width: ${(props) => (props.$hasBorder ? 1 : 0)}px;
  box-sizing: border-box;
  border-radius: ${(props) => props.$radius}px;
  background-color: ${(props) => props.$backgroundColor};
`

interface Props {
  padding?: number
  radius?: number
  children: JSX.Element | string | React.ReactNode
  hasBorder?: boolean
  backgroundColor?: string
  onClick?: (e: MouseEvent) => void
}
const Card: FC<Props> = ({
  children,
  hasBorder = true,
  radius = 8,
  padding = 16,
  backgroundColor = COLOR.white,
  onClick,
}) => {
  return (
    <Container
      $radius={radius}
      $padding={padding}
      $hasBorder={hasBorder}
      $backgroundColor={backgroundColor}
      onClick={onClick}
    >
      {children}
    </Container>
  )
}

export default Card
